module.exports = __webpack_public_path__ + "img/headshot-mharder.f466dbe3.png";